import React from 'react';

import { useWebformContext } from '../../../../context/WebformContext';

import './style.scss';

const WebformAssessmentCount: React.FC = () => {
  const { currentPage, pages } = useWebformContext();

  return (
    <div className="WebformAssessment__Count">
      {pages.indexOf(currentPage) + 1}/{pages.length}
    </div>
  );
};

export default WebformAssessmentCount;
